'use strict';

import {SectionCtrl} from "../esfasi/sectionctrl";

export class Projectreportsoverviewctrl extends SectionCtrl {

	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	reportRows = [];

	constructor($scope, $filter, jsDataService, $mdDialog) {
		'ngInject';
		super($scope, $filter, jsDataService);
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog || angular.element(document.body).injector().get('$mdDialog');
		this.reporting = jsDataService.data.reporting;

		if (
			jsDataService.data.reporting &&
			jsDataService.data.reporting.target_groups &&
			jsDataService.data.reporting.target_groups.length > 0
		) {
			this.reportRows = jsDataService.data.reporting.target_groups.map(tg => {
				let parsedWp = [];
				if (tg.workpackages) {
					if (typeof tg.workpackages === 'string') {
						try {
							parsedWp = JSON.parse(tg.workpackages);
						} catch (e) {
							parsedWp = [];
						}
					} else if (Array.isArray(tg.workpackages)) {
						parsedWp = tg.workpackages;
					}
				}
				return {
                    id: tg.id || null,
					selectedTargetGroup: tg.target_group_id,
					explanation: tg.description,
					number: parseInt(tg.number_participated),
					selectedWorkpackages: parsedWp,
					customTargetGroup: tg.custom_target_group || null
				};
			});
		} else {
			this.addRow();
		}

	}

	onTargetGroupChange(row) {
		if (row.selectedTargetGroup !== 18) {
			if (row.customTargetGroup) {
				row.customTargetGroupCache = row.customTargetGroup;
			}
			row.customTargetGroup = null;
		} else {
			if (row.customTargetGroupCache) {
				row.customTargetGroup = row.customTargetGroupCache;
			}
		}
	}

	revertTargetGroup(row) {
		if (row.customTargetGroupCache) {
			row.selectedTargetGroup = row.customTargetGroupCache;
		} else {
			const groups = this.jsDataService.data.cfgClassif.target_groups;
			const defaultGroup = groups.find(g => parseInt(g.id) !== 18);
			row.selectedTargetGroup = defaultGroup ? parseInt(defaultGroup.id) : null;
		}
		row.customTargetGroup = null;
		this.$scope.ctrlBaseForm.$setDirty();
	}

	go2Url(urlString) {
		this.$scope.goUrl(urlString);
	}

	autosavePostFields() {
		return {
			summary_41_attachment_title: this.reporting.summary_41_attachment_title ?? '',
			summary_41_top_description: this.reporting.summary_41_top_description ?? '',
			summary_41_description: this.reporting.summary_41_description ?? '',
			summary_42_description: this.reporting.summary_42_description ?? '',
			summary_43_description: this.reporting.summary_43_description ?? '',
			summary_44_description: this.reporting.summary_44_description ?? '',
			target_groups: this.reportRows.map(row => ({
                id: row.id || null,
                target_group_id: parseInt(row.selectedTargetGroup),
				customTargetGroup: row.selectedTargetGroup == 18 ? row.customTargetGroup : null,
				description: row.explanation,
				number_participated: row.number,
				workpackages: row.selectedWorkpackages
			})),
			report_id: this.reporting.id,
			project_id: this.reporting.project_id,
			comm_diss_visi: this.reporting.comm_diss_visi ?? '',
			gender_equality: this.reporting.gender_equality ?? '',
			non_discrimination: this.reporting.non_discrimination ?? '',
			transnational: this.reporting.transnational ?? '',
			sustainability_continuation: this.reporting.sustainability_continuation ?? '',
		};
	}

	isFinalReport(){
		return (this.jsDataService.data.workpackages.length > 0 && this.jsDataService.data.workpackages[0].belongs_to_final_reporting);
	}

	addRow() {
		this.reportRows.push({
			selectedTargetGroup: null,
			explanation: '',
			number: null,
			selectedWorkpackages: []
		});
	}

	removeRow(index) {
		this.reportRows.splice(index, 1);
		this.$scope.ctrlBaseForm.$setDirty();
	}

	manageFiles(ev, reporting){
		this.wFilesEditor(ev, reporting);
	}

	wFilesEditor(ev, reporting){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "$http", "jsDataService", "notify", "reporting",  this.wpFileEditorDialogCtrl],
			templateUrl: 'projects/ng_periodic_section_file_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				reporting: reporting
			}
		}).then((results) => {
			this.postAction(results);
		}, () => {});
	}

	wpFileEditorDialogCtrl($scope, $mdDialog, $filter, $http, jsDataService, notify, reporting){
		$scope.fileFilter = jsDataService.get('cfgFileFilter', {});
		$scope.maxFileSize = jsDataService.get('maxFileSize', 0);
		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');

		$scope.dragClass = '';
		$scope.reporting = reporting;

		$scope.attfile = {
			file: {}
		};
		$scope.dragClass = '';

		$scope.classif = angular.copy(jsDataService.get('cfgClassif', {}));

		$scope.fileUploaded = function($file, $message, $flow){
			if($file.response.success){
				$scope.attfile.file.file_id = $file.response.fileId;
				$scope.attfile.file.done = true;
				$scope.saveAttachment($scope.attfile, jsDataService.data.sectionitem.key);
			}
		};


		$scope.filesAdded = function($files){
			return true;
		};

		$scope.fileAdded = function($file){
			const ext = $file.getExtension();
			if(typeof($scope.fileFilter[ext]) === 'undefined' || !$scope.fileFilter[ext]){
				notify($filter('tr')('file_wrong_format'), true);
				return false;
			}
			if(typeof($scope.maxFileSize) !== 'undefined' && $file.size > $scope.maxFileSize){
				notify($file.name + ' - ' + $filter('tr')('file_size_error'), true);
				return false;
			}
			if(!$scope.activeUpload()){
				return false;
			}
			$scope.addFlowFile($file);
			return true;
		};

		$scope.fileSubmited = function(){
			$scope.attfile.flow.upload();
		};

		$scope.activeUpload = function(){
			return true;
		};

		$scope.classOnDrag = function(value){
			if($scope.activeUpload()){
				$scope.dragClass = value;
			}
		};

		$scope.classOffDrag = function(value){
			$scope.dragClass = value;
		};

		$scope.addFlowFile = function($file){
			$scope.attfile.file = {
				file_id: '0',
				nrId: $file.uniqueIdentifier,
				file_name: $file.name,
				isFlow: true,
				flowFile: $file,
				done: false
			};
		};

		$scope.editDisabled = function(){
			return false;
		};

		$scope.saveAttachment = function(attachment, sectionKey){
			if($scope.editDisabled()){
				return;
			}
			let data = {
				file_id: attachment.file.file_id,
				title: attachment.file.file_name.replace(/\.[a-z0-9]+$/, ''),
				report_id: $scope.reporting.id,
				project_id: $scope.reporting.project_id,
				sectionKey: sectionKey,
			};
			if($scope.reporting.file_add_url && $scope.reporting.file_add_url !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: $scope.reporting.file_add_url,
					method: 'POST',
					data: data
				}).then((response) => {
					if(response.data.success && response.data.item){
						reporting.attachments = response.data.item.attachments;
						$scope.reporting.attachments = reporting.attachments;
						$scope.attfile.file = {};
					}
				}, () => {});
			}
			else{
				console.log('no url ', $scope.reporting.file_add_url);
			}
		};

		$scope.removeAttachment = function(ev, attachment){
			if($scope.editDisabled()){
				return;
			}
			if($scope.reporting.file_remove_url !== ''){
				const confirmTexts = jsDataService.get('attachmentRemoveConfirmTexts');
				const confirm = $mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.multiple(true)
					.cancel(confirmTexts.cancel);
				$mdDialog.show(confirm).then(() => {
					$scope.$root.basicHttpConfigProcess({
						url: $scope.reporting.file_remove_url,
						method: 'GET',
						responseType: 'json',
						params: {
							id: attachment.id,
							report_id: $scope.reporting.id,
							project_id: $scope.reporting.project_id,
						}
					}).then((response) => {
						if(response.data.success && typeof(response.data.item) !== 'undefined'){
							$scope.reporting.attachments = response.data.item.attachments;
						}
					});
				}, () => {});
			}
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.isValid = function(){
			if($scope.editDisabled()){
				return false;
			}
			return ($scope.wp.attachments && $scope.wp.attachments.length>0 && $scope.wp.description!=='');
		};

		$scope.allowRemoveSite = function(attachment){
			return (attachment.allowremove);
		};

		$scope.getClassif = function(name){
			if(typeof($scope.classif[name]) === 'undefined'){
				return [];
			}
			if(typeof($scope.classif[name][0].active) === 'undefined'){
				return $scope.classif[name];
			}
			return $filter('filter')($scope.classif[name], {active: 1});
		};
	}
}
